import {Controller} from "stimulus";

// LocalStorageController
//
// Minimal Stimulus controller to facilitate localStorage reset. Useful to help
// clean up offline form content.
//
// @see frontend/src/controllers/persisted_input_controller.ts
export default class LocalStorageController extends Controller {
  clear() {
    window.localStorage.clear();
  }
}
